import { ButtonFrame, CardSearch, PageBodyHeader, Table } from "../../component";
import { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux";
import { fetchUserList } from "../../action/generalFunc";
import { generalObj, UrlTypes } from "../../constant/object_types";

const AdminOrderReqSupervisorList = () => {
    const navigate = useNavigate();
    const [searchText, setSearchText] = useState<string>("");
    const [staffList, setStaffList] = useState<generalObj[]>([]);

    const {setModalLoading}:{setModalLoading:Function} = useOutletContext();
    const account = useSelector((state:RootState) => state.account);
     
    useEffect(() => {
        if (!account || !account.isAuthenticated) return;
        (async () => {
            let result = await fetchUserList(account.token, "staffuser", {
                "is_supervisor": true
            });
            if (result) {
                setStaffList(result.data.users);
            }
            setModalLoading(false);
        })();

    }, [account, setModalLoading]);

    const onSearch = (val:string) => {
        setStaffList((prevStaffList) => {
            return (
                prevStaffList.filter((item) => {
                    if (item.username.includes(val) || item.email.includes(val) || (item.store && val.includes(`${item.store.length}`))) {
                        item.show = true;
                    }else {
                        item.show = false;
                    }
                    return item;
                })
            )
        })
        setSearchText(val);
    }

    return (
        <>
            <PageBodyHeader title="Supervisor List" desc="List of available supervisors for stores">
                <ButtonFrame btn_text="Back" btn_style={{padding:"8px 24px", borderRadius:"8px", border:"1px solid #808280",  backgroundColor:"#808280", color:"#FFF", fontSize:"14px", fontWeight:"600", letterSpacing:"-0.4px"}} onPress={() => window.history.back()} />
            </PageBodyHeader>

            <Table table_head={["S/no", "Username", "Email", "Stores", "Action"]} th_class="white" color={"#1159AB"} thColor={"#1159AB"}
            tableSearch={<CardSearch value={searchText} onTextChange={(evt) => onSearch(evt)} />}
            headerStyle={{marginBottom: "44px"}}
            >
                <>
                    {staffList.filter((item) => `${item.username} ${item.email} ${item.stores}`.toLowerCase().includes(searchText.toLowerCase())).map((item, index) => (
                        <tr key={item.id || index}>
                            <td>{index + 1}</td>
                            <td>{item.username}</td>
                            <td>{item.email}</td>
                            <td>{item.store ? item.store.length : 0}</td>
                            <td>
                                <div className="action-buttons" style={{display: "flex", gap: "8px"}}> 
                                    <button onClick={() => navigate(`${UrlTypes.ADMIN_ORDER_REQUEST_STORE}${item.id}/`)} className={`status__container completed`} style={{width:"60px", padding:"5px"}}>View</button>  
                                </div>
                            </td>
                        </tr>
                    ))}
                </>
            </Table>
        </>
    )
}

export default AdminOrderReqSupervisorList;